'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import envSuffix from './lib/envSuffix';
import MD5 from './lib/MD5';
import { AVATAR_SIZES, RETINA_MULTIPLIER } from './Constants';
import UIAvatarDisplay from './UIAvatarDisplay/UIAvatarDisplay';
import devLogger from 'react-utils/devLogger';

var UIUnauthedHubSpotUserAvatar = /*#__PURE__*/function (_Component) {
  _inherits(UIUnauthedHubSpotUserAvatar, _Component);

  function UIUnauthedHubSpotUserAvatar(props) {
    var _this;

    _classCallCheck(this, UIUnauthedHubSpotUserAvatar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UIUnauthedHubSpotUserAvatar).call(this, props));
    _this.state = {
      shouldRender: false
    };
    return _this;
  }

  _createClass(UIUnauthedHubSpotUserAvatar, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      var imageURI = this.getHubSettingsUrl();
      var that = this;

      if (this.props._noDefaultSrc) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', imageURI);

        xhr.onerror = function () {
          return _this2.setState({
            shouldRender: false
          });
        };

        xhr.onload = function () {
          var img = new Image();
          var response = xhr.responseText;
          var binary = '';

          for (var i = 0; i < response.length; i++) {
            binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
          }

          img.src = "data:image/jpeg;base64" + btoa(binary);
          return that.setState({
            shouldRender: img.src
          });
        };

        xhr.overrideMimeType('text/plain; charset=x-user-defined');
        xhr.send();
      }

      return this.setState({
        shouldRender: imageURI
      });
    }
  }, {
    key: "getEmailHash",
    value: function getEmailHash() {
      var _this$props = this.props,
          email = _this$props.email,
          hubSpotUserEmail = _this$props.hubSpotUserEmail;
      return MD5((hubSpotUserEmail || email).toLowerCase());
    }
  }, {
    key: "getHubSettingsUrl",
    value: function getHubSettingsUrl() {
      var _this$props2 = this.props,
          hubSpotUserEmail = _this$props2.hubSpotUserEmail,
          size = _this$props2.size;
      var email = hubSpotUserEmail || this.props.email;

      if (typeof email === 'undefined') {
        return 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-avatar.png';
      }

      var sizePx = size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : AVATAR_SIZES.xl;
      var doubleDimensionForRetina = sizePx * RETINA_MULTIPLIER;
      return "https://app.hubspot" + envSuffix() + ".com/hubsettings/v1/avatar/hash/" + this.getEmailHash() + "/" + doubleDimensionForRetina;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          email = _this$props3.email,
          hubSpotUserEmail = _this$props3.hubSpotUserEmail,
          rest = _objectWithoutProperties(_this$props3, ["email", "hubSpotUserEmail"]);

      return this.state.shouldRender && /*#__PURE__*/_jsx(UIAvatarDisplay, Object.assign({}, rest, {
        hubSpotUserEmail: hubSpotUserEmail || email,
        src: this.state.shouldRender,
        displayName: hubSpotUserEmail || email
      }));
    }
  }]);

  return UIUnauthedHubSpotUserAvatar;
}(Component);

var deprecatedInFavorOf = function deprecatedInFavorOf(newPropToUse) {
  return function (props, propName, componentName) {
    if (props[propName] && !props[newPropToUse]) {
      devLogger.warn({
        message: "Use " + newPropToUse + " instead of " + propName + " in " + componentName
      });
    }

    return null;
  };
};

UIUnauthedHubSpotUserAvatar.propTypes = {
  _noDefaultSrc: PropTypes.bool,
  email: deprecatedInFavorOf('hubSpotUserEmail'),
  hubSpotUserEmail: PropTypes.string.isRequired,
  size: UIAvatarDisplay.propTypes.size
};
UIUnauthedHubSpotUserAvatar.defaultProps = {
  size: 'sm'
};
export default UIUnauthedHubSpotUserAvatar;